/* LP · Quick-add desde la tarjeta de producto (lp-card-product).
   Intercepta el submit de los formularios .lp-quick-add-form, agrega la
   variante por AJAX y abre el cart drawer del tema (no navega a /cart).
   Delegado en document → cubre tarjetas en colección, relacionados y
   recently-viewed (incluso las cargadas dinámicamente). Degrada al POST
   nativo si algo falla. No toca global.min.js/custom.js. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('lp-quick-add-form')) return;

    var idInput = form.querySelector('[name="id"]');
    var vid = idInput ? parseInt(idInput.value, 10) : 0;
    if (!vid) { return; } /* sin variante → dejar el POST nativo */

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.setAttribute('disabled', 'disabled'); }

    var drawerEl = document.querySelector('hdt-cart-drawer');
    var sid = drawerEl ? drawerEl.getAttribute('section-id') : null;
    var body = { items: [{ id: vid, quantity: 1 }] };
    if (sid) { body.sections = sid; }

    var addSucceeded = false;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function (res) {
      if (!res.ok) { throw new Error('cart/add.js error ' + res.status); }
      return res.json();
    })
    .then(function (data) {
      addSucceeded = true;
      return fetch(root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (data.sections) { cart.sections = data.sections; }
          document.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', actionAfterATC: 'open_cart_drawer', cart: cart }
          }));
          if (btn) { btn.removeAttribute('disabled'); }
        });
    })
    .catch(function (err) {
      console.warn('[lp-quick-add] error after add attempt, addSucceeded=' + addSucceeded + ':', err);
      if (addSucceeded) {
        window.location.reload();
      } else {
        if (btn) { btn.removeAttribute('disabled'); }
        form.submit();
      }
    });
  });
})();
